const ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;
const SPECIAL_PROTOCOL_PATTERN = /^(?:data|blob):/i;

function getOrigin() {
  if (typeof window === 'undefined') {
    return '';
  }

  return `${window.location.protocol}//${window.location.host}`;
}

function setMetaContent(selector, value) {
  const element = document.querySelector(selector);

  if (element) {
    element.setAttribute('content', value);
  }
}

function getHomeImage(homeSettings) {
  const image = homeSettings?.image;

  if (Array.isArray(image)) {
    return image[0]?.url || '';
  }

  return image || '';
}

export function toAbsoluteUrl(value) {
  if (!value || typeof value !== 'string') {
    return '';
  }

  if (SPECIAL_PROTOCOL_PATTERN.test(value) || value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  if (value.startsWith('//')) {
    return typeof window === 'undefined' ? value : `${window.location.protocol}${value}`;
  }

  const origin = getOrigin();
  if (!origin) {
    return value;
  }

  return `${origin}${value.startsWith('/') ? value : `/${value}`}`;
}

export function resolveSeoImage({ pageType, image, settings, homeSettings, category, item, pageSettings } = {}) {
  let source = image;

  if (source === undefined) {
    switch (pageType) {
      case 'home':
        source = getHomeImage(homeSettings);
        break;
      case 'catalog':
        source = category?.image;
        break;
      case 'item':
        source = item?.preview;
        break;
      case 'page':
        source = pageSettings?.image;
        break;
      default:
        source = '';
    }
  }

  return toAbsoluteUrl(source) || toAbsoluteUrl(settings?.logo) || '';
}

export function applySeoMeta({ title, description, ogUrl, pageType, image, settings, homeSettings, category, item, pageSettings } = {}) {
  if (typeof document === 'undefined') {
    return;
  }

  if (title !== undefined) {
    const nextTitle = title || '';
    const titleElement = document.querySelector('title');

    if (titleElement) {
      titleElement.textContent = nextTitle;
    }

    setMetaContent('meta[property="og:title"]', nextTitle);
  }

  if (description !== undefined) {
    const nextDescription = description || '';
    setMetaContent('meta[name="description"]', nextDescription);
    setMetaContent('meta[property="og:description"]', nextDescription);
  }

  if (image !== undefined || pageType || settings || homeSettings || category || item || pageSettings) {
    setMetaContent('meta[property="og:image"]', resolveSeoImage({ pageType, image, settings, homeSettings, category, item, pageSettings }));
  }

  if (ogUrl !== undefined) {
    setMetaContent('meta[property="og:url"]', toAbsoluteUrl(ogUrl) || ogUrl || '');
  }
}
